import script from "./StudentStatusGraphModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentStatusGraphModal.vue?vue&type=script&setup=true&lang=js"

import "./StudentStatusGraphModal.vue?vue&type=style&index=0&id=2ec36fbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec36fbd"]])

export default __exports__